import React, { memo } from 'react';

import { GmbLocalPost } from '../../../../models/gmb-local-post';

import { RequestGmbLocation } from '../../../../requests/company/gmb-locations';

import MostRecentLocalPosts from '../../../general/gmb-local-posts/MostRecentLocalPosts';

type Props = {
  localPostListPath: string;
  gmbLocationId: number;
};

const RecentLocalPostView: React.FC<Props> = (props: Props) => {
  const refresh = async (): Promise<GmbLocalPost[]> => {
    return await RequestGmbLocation.mostRecentLocalPosts(props.gmbLocationId);
  };

  return (
    <MostRecentLocalPosts
      localPostListPath={props.localPostListPath}
      fetchLatestLocalPosts={refresh}
      handleShowGmbLocation={RequestGmbLocation.show}
      handleGmbLocationKeyword={RequestGmbLocation.keywords}
    />
  );
};

export default memo(RecentLocalPostView);
